import { GET_PORT_QUERY } from "@/graphql";
import { useAppDispatch } from "@/redux-hooks";
import { useLazyQuery } from "@apollo/client/react";
import { setLoading, setPort } from "@/port/port-slice";
import { useCallback } from "react";

export function useFetchPort(): FetchPort {
  const dispatch = useAppDispatch();
  const [fetchPort] = useLazyQuery(GET_PORT_QUERY);

  return useCallback(async () => {
    dispatch(setLoading(true));
    const { data } = await fetchPort();

    if (data != null) {
      dispatch(setPort(data.port));
    }

    dispatch(setLoading(false));
  }, [dispatch, fetchPort]);
}

export type FetchPort = () => Promise<void>;
